import { render, staticRenderFns } from "./CompetitionAdminEntry.vue?vue&type=template&id=0dcb338b&scoped=true"
import script from "./CompetitionAdminEntry.vue?vue&type=script&lang=js"
export * from "./CompetitionAdminEntry.vue?vue&type=script&lang=js"
import style0 from "./CompetitionAdminEntry.vue?vue&type=style&index=0&id=0dcb338b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb338b",
  null
  
)

export default component.exports